<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Mail Workers'"
        :buttons="[
          {
            title: 'Refresh All Workers',
            icon: 'fa fa-sync-alt',
            emit: 'refleshAllWorkers',
          },
        ]"
        @refleshAllWorkers="refleshAllWorkers"
      ></cardHead>
      <dataTable
        :name="'MailWorkers'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        @update="updateShow = $event"
        @remove="remove"
        :rowClassRules="{
          // row style function
          danger: (params) => {
            // var numSickDays = params.data;
            return !params?.data?.IsConnected || !params?.data.IsAuthenticated;
          },
        }"
        :addContextMenuItem="getContextMenuItems"
      ></dataTable>
      <upsert
        v-if="addShow || (updateShow != null && data != null)"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        :operators="data"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
import moment from "moment";
export default {
  name: "MailWorkers",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 80,
        },
        {
          headerName: "IP",
          field: "IP",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "CheckDate",
          field: "CheckDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 180,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "IsConnected",
          field: "IsConnected",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 180,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsAuthenticated",
          field: "IsAuthenticated",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 180,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(
          `KOLAYREZ/MailWorkers/Status
`
        )
        .then((response) => {
          this.data = response.data;
        });
    },
    getContextMenuItems(params) {
      let result = ["copy", "export"];

      result.push({
        name: "Reload",
        icon: "<i class='fa fa-sync-alt'></i>",
        action: () => {
          this.get();
        },
      });

      result.push({
        name: "Reconnect",
        icon: "<i class='fas fa-plug'></i>",
        action: () => {
          // this.paximumShow = params.node.data;
          window.open(
            "http://" + params.node.data.IP + "/Connection/ReConnect",
            "_blank",
            "location=yes,height=570,width=520,scrollbars=yes,status=yes"
          );
        },
      });
      return result;
    },
    refleshAllWorkers() {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text: "Are you sure you want to reflesh the all workers?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get("Timer/UpdateMailWorkerStatus")
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The all mail worker has been successfully refleshed.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              setTimeout(() => {
                this.get();
              }, 5000);
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
